/* Impression SCDM - toutes les donnees modifiables. Modifier ICI, jamais scdm.js.

   GRILLE DE PRIX (1er septembre 2026)
   Calee sur un audit au navigateur de StickerApp.ca, Sticker Mule (CA) et
   StickerCanada, releve prix par prix. Positionnement retenu : 4 % au-dessus
   du plus cher des deux concurrents comparables (StickerApp et Sticker Mule)
   a chaque point de la grille. StickerCanada est exclu de la reference : leur
   tarif au volume est hors de ce que l atelier peut suivre.

   VERIFIE LE 11 SEPTEMBRE 2026 : la grille des autocollants est exactement la
   ou elle doit etre. 4,0 a 5,6 % au-dessus du meilleur prix canadien affiche
   sur les quatre paliers du 2 po, et SOUS deux imprimeurs ontariens a vitrine.
   ON N Y TOUCHE PAS.

   Sous 50 unites, les concurrents ne vendent pas : la degressivite maison
   s applique (10 u = 41 % du prix a 50 u, 25 u = 68 %).

   GRILLE = tableau de reference. Les formats et quantites intermediaires sont
   interpoles : sur la SURFACE pour la taille, lineairement pour la quantite.
   Pour changer un prix, changez le nombre ici. Rien d autre a toucher.

   GRANDS FORMATS - 14, 18, 24, 30 et 36 po (5 septembre 2026)
   A VALIDER PAR LE PROPRIETAIRE. Aucun concurrent ne vend ces formats : il n y
   avait rien a comparer. Ils sont extrapoles de la grille existante, quantite
   par quantite, avec l exposant de surface mesure entre le 10 po et le 12 po
   (0,82 a 10 unites, 0,94 a 1000 : une grande piece coute proportionnellement
   moins de mise en course). Verification : recalculee de cette facon, la ligne
   du 14 po tombe a moins de 2 % de celle qui etait deja en ligne.

   ON A ENFIN DE QUOI COMPARER (11 septembre 2026). Deux imprimeurs affichent
   un prix pour un grand autocollant de vinyle nu a l unite : 56,85 $ (Quebec)
   et 65,00 $ (Ontario) pour un 24 x 36, 55,00 $ (Ontario) pour un 18 x 24.
   La grille en sortait pres du double. Ce n est PAS la grille qu on a changee
   — elle sert aussi aux autocollants, qui sont bien places — mais le PLAFOND
   des grands formats, dans scdm.js. Voir la note de PLAFOND_PAR_PI2.

   Pourquoi ces formats : la signalisation routiere. Un panneau du MTQ fait
   600 mm de cote, soit 23,6 po - la grille s arretait a 12 po et ne pouvait
   pas les servir. Le 24 po est le format normal d un panneau de route.

   LES COLONNES 1, 2 ET 5 (5 septembre 2026, apres l audit d Affiche Expert)
   Sous dix exemplaires, scdm.js n avait aucun chiffre : il extrapolait avec
   une puissance 0,55 a partir de la colonne des dix. Ca marche sur un petit
   autocollant, ou la mise en course pese lourd. Sur un panneau de 600 mm, ca
   donnait 159 $ la piece - soit 41 $ le pied carre, deux a trois fois le
   tarif du metier. On ecrit donc les trois colonnes qui manquaient.

   La regle appliquee au-dessus de 144 po2 (12 po de cote) :

       prix = le PLUS BAS de la grille extrapolee
              et de 34 $ de mise en course + 5,50 $ le pied carre

   Sous 12 po, rien ne bouge : les valeurs des colonnes 1, 2 et 5 sont
   exactement celles que scdm.js calculait deja. */
window.SCDM_DATA = {
  MIN_COMMANDE: 40,

  /* ---------------------------------------------------------------
     CODES PROMO PERMANENTS
     DOIVENT correspondre EXACTEMENT aux reductions creees dans Shopify
     (Admin > Reductions). Si les deux ne concordent pas, le client voit un
     prix et en paie un autre : au Quebec, un prix annonce doit etre honore
     (Loi sur la protection du consommateur). Changez un pourcentage ici ET
     dans Shopify, jamais un seul des deux.

     CORRIGE LE 11 SEPTEMBRE 2026 : ces cinq codes etaient restes a 0.10 alors
     que la page « Promotions » de la boutique, la table de SECOURS de
     assets/scdm-promos-cal.js et les reductions Shopify disent toutes 15 %.
     Le client ne voyait pas l erreur, parce que scdm-promos-cal.js REMPLACE
     cette table en entier (« D.CODES = {} » puis recopie de ce qu il a lu sur
     la page) : la valeur qui s appliquait etait bien 0.15. Mais le jour ou
     scdm-promos-cal.js ne se chargerait pas, assets/scdm.js relirait la table
     ci-dessous et accorderait 10 % la ou la boutique en promet 15. Un prix
     annonce doit etre honore : le chiffre est remis au bon.
     --------------------------------------------------------------- */
  CODES: {
    'POF27': 0.15,
    'GEN09': 0.15,
    'JPF15': 0.15,
    'JOE69': 0.15,
    'PAT69': 0.15
  },

  /* Rabais automatiques : aucun code a entrer, ils s appliquent tout seuls.
     Doivent aussi correspondre aux rabais automatiques de Shopify.
     NON CUMULABLES avec un code promo : Shopify applique l un OU l autre. */
  PROMOS_AUTO: [
    { nom: 'Spécial Halloween', debut: '2026-10-01', fin: '2026-11-01',
      paliers: [ { min: 300, pct: 0.20 }, { min: 150, pct: 0.15 }, { min: 75, pct: 0.10 } ] }
  ],

  /* Prix total en dollars, avant taxes, avant options. Cle = cote en pouces. */
  GRILLE: {
    '0.75': { 1: 8, 2: 12, 5: 19, 10: 28, 25: 46, 50: 68, 75: 72, 100: 75, 150: 84, 200: 91, 250: 97, 300: 102, 500: 125, 750: 153, 1000: 175, 2000: 259 },
    '1': { 1: 8, 2: 12, 5: 20, 10: 29, 25: 47, 50: 69, 75: 74, 100: 78, 150: 87, 200: 95, 250: 102, 300: 108, 500: 135, 750: 165, 1000: 191, 2000: 287 },
    '1.5': { 1: 8, 2: 12, 5: 20, 10: 30, 25: 50, 50: 73, 75: 80, 100: 85, 150: 97, 200: 107, 250: 117, 300: 125, 500: 161, 750: 202, 1000: 237, 2000: 368 },
    '2': { 1: 9, 2: 13, 5: 22, 10: 32, 25: 54, 50: 78, 75: 87, 100: 94, 150: 111, 200: 124, 250: 137, 300: 149, 500: 197, 750: 252, 1000: 301, 2000: 481 },
    '2.5': { 1: 10, 2: 14, 5: 24, 10: 35, 25: 58, 50: 85, 75: 97, 100: 107, 150: 128, 200: 146, 250: 164, 300: 180, 500: 244, 750: 318, 1000: 384, 2000: 625 },
    '3': { 1: 11, 2: 16, 5: 26, 10: 38, 25: 64, 50: 93, 75: 109, 100: 122, 150: 149, 200: 172, 250: 196, 300: 218, 500: 301, 750: 397, 1000: 483, 2000: 800 },
    '3.5': { 1: 12, 2: 17, 5: 29, 10: 42, 25: 70, 50: 102, 75: 122, 100: 138, 150: 172, 200: 200, 250: 230, 300: 257, 500: 360, 750: 480, 1000: 590, 2000: 990 },
    '4': { 1: 13, 2: 19, 5: 31, 10: 46, 25: 77, 50: 113, 75: 136, 100: 156, 150: 197, 200: 233, 250: 269, 300: 302, 500: 429, 750: 575, 1000: 710, 2000: 1200 },
    '5': { 1: 16, 2: 23, 5: 38, 10: 56, 25: 93, 50: 136, 75: 169, 100: 197, 150: 254, 200: 305, 250: 355, 300: 402, 500: 580, 750: 785, 1000: 975, 2000: 1675 },
    '6': { 1: 19, 2: 28, 5: 46, 10: 68, 25: 113, 50: 165, 75: 209, 100: 247, 150: 324, 200: 393, 250: 460, 300: 525, 500: 765, 750: 1045, 1000: 1300, 2000: 2250 },
    '8': { 1: 28, 2: 40, 5: 67, 10: 98, 25: 163, 50: 239, 75: 311, 100: 374, 150: 500, 200: 615, 250: 730, 300: 835, 500: 1235, 750: 1700, 1000: 2130, 2000: 3715 },
    '10': { 1: 39, 2: 57, 5: 94, 10: 137, 25: 227, 50: 333, 75: 441, 100: 535, 150: 730, 200: 905, 250: 1075, 300: 1235, 500: 1840, 750: 2540, 1000: 3195, 2000: 5600 },
    '12': { 1: 52, 2: 76, 5: 126, 10: 185, 25: 306, 50: 448, 75: 600, 100: 735, 150: 1010, 200: 1255, 250: 1495, 300: 1720, 500: 2580, 750: 3570, 1000: 4495, 2000: 7905 },
    '14': { 1: 54, 2: 76, 5: 130, 10: 235, 25: 390, 50: 570, 75: 770, 100: 955, 150: 1320, 200: 1645, 250: 1965, 300: 2265, 500: 3420, 750: 4745, 1000: 5980, 2000: 10545 },
    '18': { 1: 66, 2: 98, 5: 192, 10: 360, 25: 595, 50: 865, 75: 1190, 100: 1490, 150: 2080, 200: 2595, 250: 3115, 300: 3595, 500: 5470, 750: 7610, 1000: 9605, 2000: 17015 },
    '24': { 1: 91, 2: 147, 5: 315, 10: 580, 25: 950, 50: 1385, 75: 1935, 100: 2460, 150: 3470, 200: 4350, 250: 5240, 300: 6060, 500: 9325, 750: 13025, 1000: 16460, 2000: 29315 },
    '30': { 1: 122, 2: 210, 5: 472, 10: 835, 25: 1375, 50: 1990, 75: 2820, 100: 3625, 150: 5165, 200: 6490, 250: 7845, 300: 9090, 500: 14105, 750: 19755, 1000: 24995, 2000: 44700 },
    '36': { 1: 161, 2: 287, 5: 665, 10: 1130, 25: 1850, 50: 2675, 75: 3835, 100: 4980, 150: 7145, 200: 9000, 250: 10905, 300: 12660, 500: 19780, 750: 27765, 1000: 35165, 2000: 63100 }
  },

  /* Paliers relies a une vraie variante Shopify : panier propre, une seule ligne.
     Toute autre quantite passe par le produit "sur mesure" au dollar.

     VIDE POUR DE VRAI DEPUIS LE 11 SEPTEMBRE 2026.

     LE COMMENTAIRE QUI ETAIT ICI ETAIT FAUX. Il annoncait « vide depuis le
     4 septembre 2026 » alors que la table portait encore TRENTE-QUATRE
     identifiants de variantes, appartenant a SIX PRODUITS ARCHIVES. Rien ne
     cassait a l ecran, et voici pourquoi : assets/scdm-panier-technique.js
     fait « D.VARIANTES = {} » a son chargement, donc l objet etait deja vide
     avant le premier clic. Mais tout le filet tenait a cette seule ligne, dans
     ce seul fichier. Si scdm-panier-technique.js ne se chargeait pas, ou se
     chargeait trop tard, assets/scdm.js serait alle lire cette table (chercher
     « D.VARIANTES[d.taille] ») et aurait mis au panier l identifiant d une
     variante de produit archive — une ligne morte, impossible a payer.

     La table est donc videe A LA SOURCE. Le filet de scdm-panier-technique.js
     reste en place, mais il n a plus rien a rattraper.

     NE REMETTEZ RIEN ICI. Rattacher une quantite a une variante figee
     reconstruirait exactement ce piege. Tout passe par le produit technique
     au cent, et c est tres bien ainsi. */
  VARIANTES: {},

  /* Produit technique a 1,00 $ : sert aux supplements ET aux commandes hors grille */
  SUPPLEMENT: 52580141039896,

  TAILLES: [
    { id: '0.75', label: '¾ po',  mm: '19 mm',  po: 0.75 },
    { id: '1',    label: '1 po',      mm: '25 mm',  po: 1 },
    { id: '1.5',  label: '1½ po', mm: '38 mm',  po: 1.5 },
    { id: '2',    label: '2 po',      mm: '51 mm',  po: 2 },
    { id: '2.5',  label: '2½ po', mm: '64 mm',  po: 2.5 },
    { id: '3',    label: '3 po',      mm: '76 mm',  po: 3 },
    { id: '3.5',  label: '3½ po', mm: '89 mm',  po: 3.5 },
    { id: '4',    label: '4 po',      mm: '102 mm', po: 4 },
    { id: '5',    label: '5 po',      mm: '127 mm', po: 5 },
    { id: '6',    label: '6 po',      mm: '152 mm', po: 6 },
    { id: '8',    label: '8 po',      mm: '203 mm', po: 8 },
    { id: '10',   label: '10 po',     mm: '254 mm', po: 10 },
    { id: '12',   label: '12 po',     mm: '305 mm', po: 12 },
    { id: '14',   label: '14 po',     mm: '356 mm', po: 14 },
    { id: '18',   label: '18 po',     mm: '457 mm', po: 18 },
    { id: '24',   label: '24 po',     mm: '610 mm', po: 24 },
    { id: '30',   label: '30 po',     mm: '762 mm', po: 30 },
    { id: '36',   label: '36 po',     mm: '914 mm', po: 36 }
  ],

  QTE_RAPIDES: [25, 50, 100, 250, 500, 1000],

  /* UN SEUL EXEMPLAIRE EST PERMIS depuis le 5 septembre 2026. La signalisation
     se commande a l unite : une municipalite qui remplace un panneau en prend
     un, pas dix. Le minimum de commande de 40 $ protege la marge, donc rien a
     perdre a laisser passer la quantite 1. */
  QTE_MIN: 1,
  QTE_MAX: 10000,

  FORMES: [
    { id: 'carre',   label: 'Carré',          sup: 0 },
    { id: 'arrondi', label: 'Coins arrondis', sup: 0 },
    { id: 'rond',    label: 'Rond',           sup: 0 },
    /* GRATUITE depuis le 6 septembre 2026. Elle valait 15 $ par design — un
       frais unique, donc 0,60 $ la piece a vingt-cinq exemplaires, mais 15 $
       sur un seul autocollant de 13 $. Le marche de l autocollant
       (Sticker Mule, StickerApp) inclut la decoupe a la forme sans supplement :
       c est leur defaut, et un frais visible a cet endroit fait fuir avant meme
       que le client ait vu le prix au volume. Le travail de tracage reste reel,
       il est desormais porte par le prix de base. */
    { id: 'contour', label: 'À la forme',     sup: 0 }
  ],

  /* ---------------------------------------------------------------
     MATIERES  (revision du 9 septembre 2026 — LISTE REFAITE)

     CETTE LISTE NE DECRIT QUE LE VINYLE. Le support rigide (alupanel,
     coroplast) n est PAS une matiere : c est ce sur quoi on colle le vinyle,
     et il a sa propre rangee, en bas du configurateur. Voir scdm-panneau.js.

     CE QUI A CHANGE. La liste comptait quinze entrees heritees d une etude de
     marche : holographique, paillete, miroir, or, alu brosse, kraft,
     phosphorescent, fluo, transparent sans blanc d appui, noir lustre, rouge
     cerise. LA PRESSE DE L ATELIER NE PEUT PAS LES IMPRIMER. Les afficher,
     meme marquees « rupture », promettait des produits qui ne sortiront jamais.
     Il reste SIX matieres, et ce sont les six qu on sait faire.

     LE REFLECHISSANT PRISMATIQUE EST SORTI LE 9 SEPTEMBRE 2026. L atelier
     n en a qu un echantillon de cinq verges, pas un rouleau : on ne peut pas
     le vendre. Il disparait aussi de la page Materiaux, du menu de la
     soumission et de la table des poids. Un panier ou un modele qui le
     nommerait encore ne plante pas : matiereOuRepli() dans scdm.js retombe
     sur le blanc mat.

     TOUS LES SUPPLEMENTS SONT AU POUCE CARRE. Plus aucun pourcentage :
     un pourcentage du prix de base descend avec le rabais de volume, alors
     que la matiere, elle, ne baisse jamais — la centieme piece consomme
     exactement autant de film et d encre que la premiere. Au pouce carre, le
     supplement suit la surface reellement posee et reste hors du rabais.

     D OU VIENNENT LES CHIFFRES. Chaque parPo2 est un ECART par rapport au
     vinyle blanc mat, qui est compris dans la grille. La facon de le calculer
     et les montants qui y entrent ne sont PAS ecrits ici : ce fichier part au
     navigateur, et le detail de ce que l atelier paie ses rouleaux et son
     encre ne regarde personne d autre que le proprietaire. La methode et les
     factures vivent dans sa note d atelier, hors du site.

     LES QUATRE SUPPLEMENTS ONT ETE REFAITS LE 11 SEPTEMBRE 2026, chacun
     contre ce qu il coute vraiment et contre les prix affiches du marche.
     Les notes de chaque ligne disent ce qui a change et pourquoi.

     LE CHAMP note NE PORTE PLUS AUCUN MONTANT  (11 septembre 2026)

     Le proprietaire : « Je ne suis pas un fan d afficher les prix comme ca.
     Je ne suis pas fan de montrer nos prix des materiaux. » Il a demande
     qu on aille VERIFIER ce que font les autres avant de decider.

     RELEVE FAIT LE 11 SEPTEMBRE 2026 SUR QUINZE VITRINES, du Quebec, de
     l Ontario et d ailleurs au Canada. Resultat : AUCUNE n affiche un tarif
     au pied carre a cote d un choix de matiere. Zero sur quinze. Les trois
     facons qui existent sont : ne rien afficher du tout et laisser le total
     bouger (la majorite), afficher un forfait par quantite deja tout
     compris, ou decrire la matiere en mots sans aucun chiffre. Le seul pied
     carre rencontre est une accroche de page d accueil (« a partir de
     1,02 $/pi2 »), jamais une ligne de prix collee a une matiere.

     Le tarif au pied carre etait devenu doublement nuisible ici : il annonce
     la STRUCTURE DE COUT de l atelier a qui veut la lire, et il est faux au
     ressenti du client, qui prend une petite pancarte ou la mise en course
     pese bien plus que la surface. Le prix en direct existe maintenant dans
     le configurateur : le client VOIT le total bouger quand il change de
     matiere. Le montant au pied carre ne servait donc plus a rien.

     note = une ECHELLE RELATIVE, sans aucun chiffre. Cinq echelons :

         'Inclus'          compris dans le prix affiche, aucun supplement
         'Supplément +'    supplement leger
         'Supplément ++'   supplement moyen
         'Supplément +++'  supplement important
         'Supplément ++++' la matiere la plus chere du magasin

     L echelle doit rester DANS LE MEME ORDRE que les parPo2 ci-dessous : si
     vous changez un parPo2, verifiez que son echelon est encore au bon rang.
     C est la seule regle. Il n y a plus rien a convertir, plus de nombre a
     garder synchronise, et donc plus moyen que l ecran annonce un tarif que
     le panier ne facture pas. La legende des echelons est ecrite sous la
     rangee des matieres par assets/scdm-decoupe-seulement.js, dans
     poserLegende() : elle se lit a l ecran, sous les cases.

     ET ELLE NE VIT QU ICI. Un bloc de assets/scdm-matieres.css a longtemps
     masque ce champ et l a remplace par une mention ecrite en dur, matiere
     par matiere. Ce bloc a ete retire le 11 septembre 2026 : il etait deja
     faux, parce que le tarif du lettrage avait bouge et pas lui. NE LE
     REFAITES PAS. Pour changer une mention, changez note, ici, et rien
     d autre.

     pct      = pourcentage du prix de base (plus utilise sur les matieres)
     parPo2   = supplement par pouce carre et par exemplaire — CE QUI EST
                CALCULE. Ne se montre nulle part a l ecran.
     min      = plancher en dollars pour l ensemble de la ligne
     base     = couleur du support dans l apercu
     brillant = ajoute le reflet dans l apercu
     stock    = false -> affiche, marque RUPTURE, non selectionnable
     devis    = true  -> selectionnable, mais pas de prix : vers la soumission
     decoupeSeulement = true -> la matiere se DECOUPE et ne s imprime pas.
                Voir assets/scdm-decoupe-seulement.js : la mention s affiche
                pres du choix, part sur la commande, et un visuel photo
                televerse bloque l ajout au lieu d etre converti en silence.
     --------------------------------------------------------------- */
  MATIERES: [
    { id: 'blanc-mat',         label: 'Vinyle blanc mat',                     sw: 'sw-blancmat',    parPo2: 0,      min: 0,  note: 'Inclus',        stock: true,  base: '#FBFAF6' },
    /* BAISSE LE 11 SEPTEMBRE 2026. Le supplement du blanc brillant a ete
       ramene a un peu plus du tiers de ce qu il etait. Raison : l ecart de
       film avec le blanc mat est petit, et le marche de l autocollant offre
       ce fini sans supplement. Le plancher descend de 8 $ a 6 $ avec lui.
       CE QUI A ETE MESURE POUR EN ARRIVER LA — cout du film, cout de
       l encre, temps de main-d oeuvre, perte de mise en course — n est PAS
       ecrit ici. Ce fichier part au navigateur : tout le monde peut le
       lire, concurrents compris. Les mesures sont dans la note d atelier
       du proprietaire, hors du site.

       PLUS AUCUN MONTANT DANS note : c est une ECHELLE RELATIVE.
       Inclus < + < ++ < +++ < ++++. Voir LE CHAMP note, en tete des
       MATIERES. Le prix, lui, se lit sur le total, en direct. */
    { id: 'blanc-brillant',    label: 'Vinyle blanc brillant',                sw: 'sw-blanclustre', parPo2: 0.00625, min: 6, note: 'Supplément +',    stock: true,  base: '#FFFFFF', brillant: true },
    /* GRATUIT depuis le 9 septembre 2026. L ecart avec le blanc mat est trop
       petit pour valoir une ligne de prix. Il devient le DEUXIEME STANDARD,
       offert pour sa largeur. Aucun parPo2, aucun min : comme le blanc mat.

       A VERIFIER AVEC LE PROPRIETAIRE (11 septembre 2026) : l inventaire
       qu il a confirme ne nomme pas de rouleau « economique » distinct du
       blanc mat. Tant que ce n est pas tranche, on ne touche a rien — la
       ligne ne coute rien au client et ne casse aucun prix. */
    { id: 'economique',        label: 'Vinyle économique',                    sw: 'sw-eco',         parPo2: 0,      min: 0,  note: 'Inclus',        stock: true,  base: '#F1F0EB' },
    /* BAISSE LE 11 SEPTEMBRE 2026, d environ un quart. Le film clair demande
       une couche de blanc imprimee derriere le visuel, en plus du film
       lui-meme : le supplement reste donc reel. Il cesse simplement d ajouter
       un tiers au prix d une commande de mille autocollants.
       CE QUI A ETE MESURE POUR EN ARRIVER LA — cout du film, cout de
       l encre, temps de main-d oeuvre, perte de mise en course — n est PAS
       ecrit ici. Ce fichier part au navigateur : tout le monde peut le
       lire, concurrents compris. Les mesures sont dans la note d atelier
       du proprietaire, hors du site.

       PLUS AUCUN MONTANT DANS note : c est une ECHELLE RELATIVE.
       Inclus < + < ++ < +++ < ++++. Voir LE CHAMP note, en tete des
       MATIERES. Le prix, lui, se lit sur le total, en direct. */
    { id: 'transparent-blanc', label: 'Vinyle transparent', sw: 'sw-clair',      parPo2: 0.0138889, min: 10, note: 'Supplément ++', stock: true,  base: '#F2F4F5' },
    /* FORTEMENT RELEVE LE 11 SEPTEMBRE 2026. L ancien supplement etait une
       erreur de construction, pas un choix.

       Le lettrage n est PAS imprime : on decoupe, puis on ECHENILLE a la
       main, lettre par lettre, et on pose un ruban de transfert. C est un
       travail long, et c est de la main-d oeuvre presque pure. L ancien
       tarif ne tenait pas compte de ce temps de main ; le nouveau si, a
       toutes les quantites.
       REVU UNE TROISIEME FOIS LE 11 SEPTEMBRE 2026, EN FIN DE JOURNEE, ET
       IL MONTE BEAUCOUP. Le proprietaire a repris la mesure de l echenillage
       dans sa note d atelier, hors du site : ce travail se compte au pied
       carre, et le tarif precedent ne suivait pas cette mesure. Le lettrage
       devient la ligne la plus chere du magasin — devant le reflechissant —
       et c est la verite du metier : on ne vend pas du film, on vend des
       heures de main.
       Le plancher monte de 12 $ a 20 $ : meme une petite piece demande son
       rouleau de ruban de transfert.

       CE QUE CA DONNE FACE AU MARCHE. Un seul atelier au Canada affiche un
       prix public pour du lettrage decoupe, et notre tarif est plusieurs fois
       au-dessus. Deux lectures possibles, et on ne peut pas trancher d ici :
       ou bien ils vendent de grandes lettres simples, ou le pied carre
       s echenille beaucoup plus vite que ce qu on a retenu, ou bien ils
       vendent sous leur cout. Un chronometrage d un vrai echenillage
       trancherait en une heure — c est la mesure la plus rentable a faire.

       LE NOIR ET LE ROUGE CERISE SONT DANS CE TARIF-LA, ET AU MEME PRIX QUE
       LE BLANC. Les trois rouleaux de decoupe se valent, et le travail —
       decoupe, echenillage, ruban — est identique. Faire une ligne de prix
       pour un ecart aussi mince ferait hesiter le client bien plus qu elle
       ne rapporterait. Voir aussi
       COULEURS_LETTRAGE, plus bas : il n y a volontairement AUCUN champ de
       prix dans cette table.
       CE QUI A ETE MESURE POUR EN ARRIVER LA — cout du film, cout de
       l encre, temps de main-d oeuvre, perte de mise en course — n est PAS
       ecrit ici. Ce fichier part au navigateur : tout le monde peut le
       lire, concurrents compris. Les mesures sont dans la note d atelier
       du proprietaire, hors du site.

       PLUS AUCUN MONTANT DANS note : c est une ECHELLE RELATIVE.
       Inclus < + < ++ < +++ < ++++. Voir LE CHAMP note, en tete des
       MATIERES. Le prix, lui, se lit sur le total, en direct. */
    { id: 'lettrage',          label: 'Lettrage découpé',                     sw: 'sw-noirlustre',  parPo2: 0.1285, min: 20, note: 'Supplément ++++',   stock: true,  base: '#101014', brillant: true, decoupeSeulement: true },
    /* LA HAUSSE DE SOIREE DU 11 SEPTEMBRE 2026 EST ANNULEE. Sur decision du
       proprietaire, le tarif de ce film revient a sa valeur precedente.
       Raison : combinee a la pellicule devenue obligatoire sur les panneaux
       du Repertoire, elle sortait le panneau fini du marche releve. La
       pellicule obligatoire, elle, reste en place. Le reste de cette note
       est conserve : le raisonnement et l hypothese qui portait la hausse
       restent utiles si la question revient.

       REVU DEUX FOIS LE 11 SEPTEMBRE 2026, puis fixe en fin de journee. Il
       avait ete descendu trop bas le matin. Trois raisons de le remonter :
       c est un film a part, qui n a rien a voir avec un vinyle ordinaire ;
       a chaque commande l atelier perd une amorce de media sur toute la
       largeur du rouleau, et sur ce film-la cette amorce pese lourd sur une
       petite commande ; et une partie du travail demande une couche de
       blanc. Au tarif retenu, le panneau fini se place entre le fabricant
       de panneaux de serie et le fabricant d enseignes sur mesure, ce qui
       est exactement sa place.
       Le plancher reste a 30 $, parce que l amorce est perdue meme si le
       client ne commande qu une piece.
       SON ECHELON DESCEND DE ++++ A +++ LE 11 SEPTEMBRE 2026 : ce n est plus
       la matiere la plus chere du magasin, le lettrage vient de passer devant.
       L echelle doit rester dans le meme ordre que les parPo2 — c est la
       seule regle de ce champ, et c est pour ca qu ils bougent ensemble.
       CE QUI A ETE MESURE POUR EN ARRIVER LA — cout du film, cout de
       l encre, temps de main-d oeuvre, perte de mise en course — n est PAS
       ecrit ici. Ce fichier part au navigateur : tout le monde peut le
       lire, concurrents compris. Les mesures sont dans la note d atelier
       du proprietaire, hors du site.

       PLUS AUCUN MONTANT DANS note : c est une ECHELLE RELATIVE.
       Inclus < + < ++ < +++ < ++++. Voir LE CHAMP note, en tete des
       MATIERES. Le prix, lui, se lit sur le total, en direct.

       RELEVE LE 11 SEPTEMBRE 2026, EN SOIREE : +17 %. Le tarif suit la
       grille de prix. La verification croisee de neuf fournisseurs
       canadiens qui affichent un panneau reflechissant fini place la bande
       du 60e au 75e centile du marche entre 29,04 $ et 45,87 $ le pied
       carre. Nos panneaux finis sortaient entre 17,55 $ et 30,75 $ le pied
       carre, c est-a-dire sous cette bande sur presque toute la grille. Le
       supplement de ce film monte donc de 12,00 $ a 14,04 $ le pied carre,
       soit exactement 17 % — le milieu de la fourchette retenue.

       HYPOTHESE ASSUMEE, ET ELLE PORTE LA HAUSSE. Quatre des cinq releves
       quebecois viennent d une seule vitrine, et personne n a pu confirmer
       si ses montants sont affiches taxes en sus ou taxes incluses. On a
       tranche pour HORS TAXES, sur l indice que sa grille tombe sur des
       chiffres ronds au metre carre. Si l hypothese est fausse, la bande du
       marche est environ 15 % plus basse et cette hausse est trop forte :
       ramener parPo2 a sa valeur d avant, 0.0833333.

       LE PLANCHER NE BOUGE PAS. min reste a 30 $ : c est une mise en route
       — l amorce de media perdue sur la largeur du rouleau — et la hausse
       ne porte que sur le tarif a la surface.

       L ECHELON RESTE +++ : 0.0975 est toujours sous le parPo2 du lettrage,
       donc l ordre de l echelle relative est intact. */
    { id: 'reflechissant',     label: 'Vinyle réfléchissant',      sw: 'sw-refl',        parPo2: 0.0833333, min: 30, note: 'Supplément +++', stock: true,  base: '#DCE4EC', brillant: true }
  ],

  /* Descriptions affichees dans la section "Nos materiaux" de l accueil.
     Meme liste que ci-dessus : une seule source, jamais deux. */
  MATIERES_TEXTE: {
    'blanc-mat':         'Le standard, compris dans nos prix. Aucun reflet : lisible sous n’importe quel angle, même sous un éclairage direct. Largeur jusqu’à 30 po (762 mm).',
    'blanc-brillant':    'Notre vinyle polyvalent. Couleurs vives et profondes, 7 ans à l’extérieur, se retire sans laisser de colle. Jusqu’à 52 po (1321 mm) de large.',
    'economique':        'Même qualité d’impression que le blanc mat, en rouleau de 52 po (1321 mm) au lieu de 30 po (762 mm). C’est le choix quand la pancarte est trop large pour le blanc mat, ou quand la job a une date de fin connue. 5 ans à l’extérieur.',
    'transparent-blanc': 'Vinyle transparent pour vitres et surfaces lisses. Le fond reste visible dans les zones non imprimées. L’atelier valide le rendu du fichier selon son utilisation.',
    'lettrage':          'Découpe seulement — aucune impression. Vinyle de couleur pleine, taillé au contour de vos lettres ou de votre logo. La couleur est dans le vinyle : elle ne peut ni pâlir ni s’écailler. Blanc, noir ou rouge cerise. Demande un tracé vectoriel, pas une photo.',
    'reflechissant':     'Renvoie la lumière des phares la nuit, avec votre visuel imprimé en pleine couleur. Pour un panneau de signalisation routière, la pellicule dépend du devis — écrivez-nous.'
  },

  /* ---------------------------------------------------------------
     LA COULEUR DU VINYLE DE LETTRAGE  (9 septembre 2026)

     Le lettrage decoupe n est PAS imprime : on decoupe les lettres ou le logo
     directement dans un rouleau de vinyle deja colore. La couleur est donc
     dans la masse — elle ne peut ni palir ni s ecailler — et le client doit
     pouvoir dire QUEL ROULEAU monter. Sans cette rangee, l atelier avait trois
     rouleaux en stock et un seul etait atteignable.

     AUCUN SUPPLEMENT ENTRE LES TROIS COULEURS, ET C EST VOULU. Les trois
     rouleaux se valent, et le travail est rigoureusement le meme :
     meme decoupe, meme echenillage,
     meme ruban de transfert. Une ligne de prix pour un ecart aussi mince
     ferait hesiter le client bien plus qu elle ne rapporterait. Les trois
     couleurs sont donc au meme tarif que le lettrage lui-meme — c est-a-dire
     le parPo2 de la matiere 'lettrage', ci-dessus. Il n y a volontairement
     AUCUN champ de prix ici : rien a calculer, rien a oublier.

     (Les montants d achat, eux, ne sont pas ecrits ici : ce fichier part au
     navigateur. Ils sont dans la note d atelier du proprietaire.)

     hex = la vraie couleur, pour la pastille de la case. Pas une image : un
           fond de couleur, comme le sujet de la rangee l exige.

     LA RANGEE NE S AFFICHE QUE SI LE MATERIAU RETENU EST 'lettrage'. C est
     scdm.js qui en decide, dans couleurLettrageOfferte(), exactement comme
     laminageOffert() decide pour le laminage. Sur toute autre matiere, la
     rangee entiere disparait.

     ET ELLE N EST PAS UN CHOIX OBLIGATOIRE. Elle a une valeur par defaut
     (DEFAUTS.couleurLettrage, plus bas), donc elle ne doit JAMAIS entrer dans
     la liste GROUPES de scdm-vierge.js : le message « Il reste a choisir... »
     reclamerait une rangee invisible des que le client n est pas en lettrage,
     et le bouton resterait muet pour toujours. C est exactement le piege du
     9 septembre. Ne l y mettez pas.
     --------------------------------------------------------------- */
  COULEURS_LETTRAGE: [
    { id: 'blanc', label: 'Blanc brillant', hex: '#FFFFFF' },
    { id: 'noir',  label: 'Noir brillant',  hex: '#101014' },
    { id: 'rouge', label: 'Rouge cerise',   hex: '#B3121F' }
  ],

  /* Le VERNIS est une couche transparente appliquee PAR-DESSUS l impression.
     Ce n est pas la surface du vinyle : un blanc mat peut recevoir un vernis
     lustre. L identifiant reste 'lustre' : il commande le reflet de l apercu. */
  FINITIONS: [
    { id: 'standard', label: 'Sans vernis',   sw: 'sw-std',    pct: 0,    min: 0, note: 'Inclus' },
    { id: 'mat',      label: 'Vernis mat',    sw: 'sw-vmat',   pct: 0.08, min: 5, note: '+8 %' },
    { id: 'lustre',   label: 'Vernis lustré', sw: 'sw-lustre', pct: 0.10, min: 5, note: '+10 %' }
  ],

  /* ---------------------------------------------------------------
     LAMINAGE  (9 septembre 2026)

     Le laminage n est PAS le vernis. Le vernis est une couche liquide passee
     a la machine par-dessus l encre ; le laminage est une PELLICULE que l on
     deroule et que l on colle sur l impression, au laminateur. C est une
     operation a part, avec son propre montage — d ou le montant fixe.

     parPo2       = pellicule + main-d oeuvre, par pouce carre et par exemplaire
     fixeCommande = montage de la passe de lamination, EN DOLLARS. UNE SEULE
                    FOIS PAR COMMANDE, jamais par exemplaire : on cale le
                    laminateur une fois, qu il y ait une piece ou cent.
                    Applique dans totauxCommande() de scdm.js, pas dans le
                    prix d un design.
                    C EST ICI QUE VIT LE MONTANT, ET NULLE PART AILLEURS
                    (10 septembre 2026). Il vivait aussi dans scdm.js, dans
                    une constante MONTAGE_LAMINAGE, et c est elle qui
                    gagnait : changer le nombre ici ne changeait rien.
                    Corrige. POUR CHANGER LE MONTANT DU MONTAGE, changez le
                    nombre ci-dessous, et lui seul. scdm.js le lit d ici et
                    ne garde 30 $ que comme repli, si le champ manque.
                    Zero ou champ absent = ce laminage ne demande aucune
                    passe de montage.
     texte        = la phrase affichee sous la rangee quand le choix est fait

     UNE SEULE CASE, ET ELLE EST FACULTATIVE (9 septembre 2026). Le choix
     « Aucun laminage » a ete retire : il ne disait rien que l absence de
     coche ne dise deja, et il obligeait le client a choisir quelque chose
     pour un service dont il n a le plus souvent pas besoin. La rangee se
     comporte donc comme une case a cocher : on clique pour prendre la
     pellicule, on reclique pour l enlever. Pas de coche = pas de laminage,
     pas de tarif au pouce carre, pas de montage.

     NE REMETTEZ PAS d entree « aucun » ici : scdm.js traite tout
     identifiant inconnu — y compris 'aucun' et le vide — comme « pas de
     laminage » (voir AUCUN_LAMINAGE et laminageOuRepli). Ajouter une case
     « aucun » la rendrait cochable et ferait mentir la rangee.

     ET ELLE NE S AFFICHE QUE SUR UNE PANCARTE OU UN GRAND FORMAT : c est
     scdm.js qui en decide, dans laminageOffert(). Un autocollant ordinaire
     ne voit jamais cette rangee.

     ELLE N EST PAS COCHEE D AVANCE, ET C EST IMPORTANT POUR LA
     SIGNALISATION. Un panneau routier charge depuis la bibliotheque de
     modeles n emporte AUCUNE pellicule : DEFAUTS.laminage vaut 'aucun' et
     rien dans scdm-panneau.js ne le change. Le client doit cocher la case.
     Verifie dans le code le 11 septembre 2026.
     --------------------------------------------------------------- */
  /* AJUSTE LE 11 SEPTEMBRE 2026 : le tarif de la pellicule baisse d un peu
     plus d un dixieme, et le montage passe de 30 $ a 20 $. Releve du marche :
     le seul fournisseur canadien qui affiche une grille laminee ET non
     laminee fait payer l ecart sans aucun frais de montage. On garde un
     montage — la passe de lamination demande un calage reel — mais on le
     ramene, parce qu a 30 $ il doublait le prix d une seule petite pancarte.
     Ce qui a ete mesure pour en arriver la n est pas ecrit ici : ce fichier
     part au navigateur.
     PLUS AUCUN MONTANT DANS note. Le pied carre de la pellicule ne s affiche
     plus : note vaut « Supplément ++ », comme les matieres. Le montage, lui,
     RESTE ANNONCE en dollars sous la rangee — c est un frais fixe par commande,
     et scdm.js le tire de fixeCommande, pas de note. Un frais fixe annonce, le
     marche le fait (oeillets a 1,00 $, pied a 2,99 $ chez un imprimeur
     d Ottawa) ; un tarif au pied carre de la matiere, personne. */
  LAMINAGES: [
    { id: 'protection', label: 'Pellicule de protection', sw: 'sw-vmat',   parPo2: 0.0243056, fixeCommande: 20, note: 'Supplément ++',
      texte: 'Protège des UV, des égratignures et du lavage à pression. Recommandée sur tout ce qui va dehors.' }
  ],

  /* ---------------------------------------------------------------
     LAMINAGES RETIRES DU CONFIGURATEUR (9 septembre 2026)

     CE TABLEAU N EST LU PAR PERSONNE. C est une reserve, pas une liste de
     choix : scdm.js ne regarde que LAMINAGES. Rien ici ne s affiche et rien
     ici ne se calcule.

     La surface effacable a sec sort du configurateur et se vend SUR
     SOUMISSION les premiers mois — voir le choix « Tableau effacable a sec »
     dans le menu Type de projet de sections/scdm-soumission.liquid. La
     raison : on ne connait pas encore le vrai temps de fabrication, et le
     produit demande un support rigide dont le cout n est pas mesure. Vendre
     a l aveugle un prix affiche, c est se tromper cent fois de suite.

     LE RELEVE DU 11 SEPTEMBRE 2026 CONFIRME QU IL FAUT LE LAISSER LA. Six
     fournisseurs canadiens et americains de tableaux effacables sur mesure
     ont ete consultes : AUCUN n affiche de prix. Tous renvoient a une
     soumission. Il n y a donc rien a quoi se comparer, et la decision de
     vendre sur soumission est la bonne.

     COMMENT LE FAIRE REVENIR quand les couts de support rigide seront
     connus : couper la ligne ci-dessous et la recoller a la fin du tableau
     LAMINAGES, au-dessus. Revalider le parPo2 avant : 0,0472 $/po2 vient
     d une estimation, pas d une facture.
     --------------------------------------------------------------- */
  LAMINAGES_EN_ATTENTE: [
    /* note vaut « Supplément +++ » et non un tarif : si cette ligne remonte un
       jour dans LAMINAGES, elle s afficherait telle quelle, et plus aucun
       montant au pied carre ne doit paraitre a l ecran. Le parPo2 reste, lui :
       c est ce qui se calcule, et il est a revalider avant tout retour. */
    { id: 'effacable',  label: 'Surface effaçable à sec', sw: 'sw-lustre', parPo2: 0.0472, fixeCommande: 30, note: 'Supplément +++',
      texte: 'Transforme votre pancarte en tableau où on écrit au crayon feutre. Usage intérieur, sur support rigide.' }
  ],

  /* laminage: 'aucun' n est PAS une case de la rangee — c est le mot qui dit
     « rien de coche ». Voir le tableau LAMINAGES ci-dessus. */
  /* couleurLettrage: le vinyle blanc est celui qui part le plus, et une
     valeur par defaut est ce qui garde cette rangee HORS des choix
     obligatoires. Voir la note de COULEURS_LETTRAGE. */
  DEFAUTS: { taille: '3', qte: 100, forme: 'arrondi', matiere: 'blanc-mat', finition: 'standard', laminage: 'aucun', couleurLettrage: 'noir' }
};

